import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconStaticReminderFathersDay = function IconStaticReminderFathersDay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M2.86 3.79v3.721M1 5.651h3.72m3.722 30.698v3.72m-1.86-1.859h3.72M38.21 1.93v3.721M36.349 3.79h3.72"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.512,
    cy: 1.93,
    r: 0.93,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.07,
    cy: 11.232,
    r: 0.93,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.791,
    cy: 35.419,
    r: 0.93,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "M12.163 13.582a7 7 0 0 1 7-7h2.744a7 7 0 0 1 7 7v5.093H12.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    d: "m28.907 17.744.18.984a1 1 0 0 0 .82-.984zm-16.744 0h-1a1 1 0 0 0 .82.984zm1.228-6.226a1 1 0 0 0-1.917-.57zm.99-4.59a1 1 0 1 0 1.144 1.64zm4.293.654h3.721v-2h-3.72zm9.233 5.511v4.651h2v-4.65zm-14.744 4.651v-4.65h-2v4.65zm9.232-10.162a5.51 5.51 0 0 1 5.512 5.511h2a7.51 7.51 0 0 0-7.512-7.511zm-10.921 3.366a7.5 7.5 0 0 0-.311 2.145h2c0-.549.08-1.077.228-1.575zm7.2-5.366a7.5 7.5 0 0 0-4.293 1.347l1.144 1.64a5.5 5.5 0 0 1 3.15-.987zm10.233 12.162-.18-.983h-.003l-.01.002-.041.007-.163.03-.612.103a81 81 0 0 1-2.08.316c-1.674.231-3.71.456-5.283.456v2c1.717 0 3.866-.241 5.556-.475a83 83 0 0 0 2.98-.469l.011-.002h.004v-.001zm-8.372-.07c-1.573 0-3.61-.224-5.283-.455a81 81 0 0 1-2.692-.42l-.163-.029-.042-.007-.01-.002h-.002l-.18.983-.18.984h.004l.012.003.216.038a82.864 82.864 0 0 0 2.763.43c1.69.235 3.84.476 5.557.476z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M10.302 16.814s2.274 2.046 10.233 2.046 10.232-2.046 10.232-2.046"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M25.651 12.721a3.07 3.07 0 0 0-3.07-3.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    d: "M22.487 23.97c-1.14 0-1.827.49-2.028.735-.2-.244-.888-.734-2.028-.734-.892 0-1.676.24-2.501.734-.493.296-1 .683-1.554 1.164-1.48 1.285-2.193 2.877-3.837 2.877-.878 0-1.48-.673-1.534-1.286-.055-.612.737-1.21 1.534-1.102-.11-.245-.56-.744-1.425-.49-1.041.307-1.754 1.348-1.754 2.45 0 1.047.987 3.795 6.139 3.795.988 0 1.868-.087 2.644-.23 2.456-.45 3.858-1.461 4.316-2.035.603.755 2.84 2.265 6.96 2.265.805 0 1.507-.067 2.12-.183 2.082-.398 3.134-1.37 3.629-2.26.293-.526.39-1.023.39-1.353 0-1.102-.712-2.142-1.754-2.448-.864-.255-1.315.244-1.425.49.798-.108 1.59.49 1.535 1.101-.055.613-.656 1.286-1.535 1.286-1.644 0-2.356-1.592-3.836-2.877-1.48-1.286-2.63-1.898-4.056-1.898"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.609,
    cy: 22.037,
    r: 4.074,
    fill: "#fff",
    stroke: "#00204D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.608,
    cy: 22.037,
    r: 3.383,
    fill: "#fff",
    transform: "rotate(45.936 25.608 22.037)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F9",
    d: "M27.961 24.468a3.383 3.383 0 0 1-4.783-.078s2.264.162 3.607-1.138c1.342-1.299 1.254-3.567 1.254-3.567a3.383 3.383 0 0 1-.078 4.783"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC640D",
    d: "M23.217 19.645a3.383 3.383 0 0 1 4.784 0s-2.847-.705-4.168.616-.616 4.168-.616 4.168a3.383 3.383 0 0 1 0-4.784",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M30.43 21.36h2.198v2.2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.535,
    cy: 24.256,
    r: 1.86,
    fill: "#FFA6B6"
  }));
};